const RANK = {
    // 热议榜
    HOT: 1,
    // 高股息榜
    HOT_DIVIDENDS: 2,
    // 自定义
    CUSTOM: 100,
};

const MARKET = {
    HK: 'HK', // 港股
    US: 'US', // 美股
    CN: 'CN', // A股
    SG: 'SG', // 星股
    AU: 'AU', // 澳股
    CA: 'CA', // 加拿大
    JP: 'JP', // 日本
    MY: 'MY', // 马来西亚
};

const MARKET_ID = {
    // 注意: 两个榜市场枚举不一致
    [RANK.HOT]: {
        [MARKET.HK]: 1,
        [MARKET.US]: 2,
        [MARKET.CN]: 3,
        [MARKET.SG]: 4,
        [MARKET.AU]: 5,
        [MARKET.CA]: 6,
        [MARKET.JP]: 7,
        [MARKET.MY]: 8,
    },
    [RANK.HOT_DIVIDENDS]: {
        [MARKET.HK]: 1,
        [MARKET.US]: 2,
        [MARKET.CN]: 3,
        [MARKET.SG]: 4,
        [MARKET.CA]: 5,
        [MARKET.AU]: 6,
        [MARKET.JP]: 7,
        [MARKET.MY]: 8,
    }
};

export {
    RANK,
    MARKET,
    MARKET_ID
};
